<template>
  <div id="app">
    <div
      id="appCapsule"
      :class="{
        'qvp-page':
          this.$route.name === 'QVP Exam' ||
          this.$route.name === 'QVP Main' ||
          this.$route.name === 'QHLS Exam',
      }"
    >
      <app-header
        v-if="
          this.$route.name != 'OTP' &&
          this.$route.name != 'QVP Exam' &&
          this.$route.name != 'QVP Main' &&
          this.$route.name != 'QHLS Exam'
        "
        :page_header="page_header"
        :minutes="minutes"
        :seconds="seconds"
      >
      </app-header>
      <router-view :key="$route.path" />
    </div>

    <app-footer-menu
      v-if="this.$route.name != 'EPR' && this.$route.name != 'OTP' && this.$route.name != 'Login' && this.$route.name != 'Welcome' && this.$route.name != 'Register' && this.$route.name != 'UserLogin' && this.$route.name != 'Conference Registration' && this.$route.name != 'PER' && this.$route.name != 'EVBD' && this.$route.name != 'Donation' && this.$route.name != 'QVP Exam' && this.$route.name != 'QVP Main' && this.$route.name != 'QHLS Exam'">
    </app-footer-menu>
    <div class="appFooter" v-else-if="this.$route.name != 'QVP Exam' && this.$route.name != 'QVP Main' && this.$route.name != 'QHLS Exam'">
      <div class="footer-title">
        Copyright © Wisdom It Wing 2024. All Rights Reserved.
      </div>
      Wisdom Islamic Organizations
    </div>
    <!-- <div class="appFooter">
      <div class="footer-title">
        Copyright © Finapp 2021. All Rights Reserved.
      </div>
      Bootstrap 5 based mobile template.
    </div> -->
    <app-side-menu></app-side-menu>
  </div>
</template>

<script type="module">
import AppHeader from './views/layouts/AppHeader.vue';
import AppFooterMenu from './views/layouts/AppFooterMenu.vue';
import AppSideMenu from './views/layouts/AppSideMenu.vue';
import { updateEventBus } from './registerServiceWorker';

export default {
  components: {
    AppHeader,
    AppFooterMenu,
    AppSideMenu
  },
  data() {
    return {
      'page_header': null,
      'minutes': null,
      'seconds': null,
      buildVersionCheckInterval: null
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    showAdminBoard() {
      if (this.currentUser && this.currentUser['roles']) {
        return this.currentUser['roles'].includes('ROLE_ADMIN');
      }

      return false;
    },
    showModeratorBoard() {
      if (this.currentUser && this.currentUser['roles']) {
        return this.currentUser['roles'].includes('ROLE_MODERATOR');
      }

      return false;
    }
  },
  mounted() {
    this.page_header = null;
    this.minutes = null;
    this.seconds = null;
    updateEventBus.on(() => {
      this.refreshForUpdate();
    });
    this.startVersionCheck();
  },
  beforeUnmount() {
    if (this.buildVersionCheckInterval) {
      clearInterval(this.buildVersionCheckInterval);
    }
    if (this._versionCheckVisibility) {
      document.removeEventListener('visibilitychange', this._versionCheckVisibility);
    }
  },
  methods: {
    refreshForUpdate() {
      window.location.reload();
    },
    checkForAppUpdate() {
      const currentVersion = String(process.env.BUILD_VERSION || '');
      if (!currentVersion) return;
      const url = `${window.location.origin}/version.json?_=${Date.now()}`;
      fetch(url, { cache: 'no-store', credentials: 'omit' })
        .then((r) => { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then((data) => {
          if (data && data.version != null && String(data.version) !== currentVersion) {
            this.refreshForUpdate();
          }
        })
        .catch(() => {});
    },
    startVersionCheck() {
      // Check soon after load, then every 2 minutes, and whenever user returns to the tab
      setTimeout(() => this.checkForAppUpdate(), 15000);
      this.buildVersionCheckInterval = setInterval(() => this.checkForAppUpdate(), 2 * 60 * 1000);
      this._versionCheckVisibility = () => {
        if (document.visibilityState === 'visible') this.checkForAppUpdate();
      };
      document.addEventListener('visibilitychange', this._versionCheckVisibility);
    },
    updateParent(variable) {
      this.page_header = variable;
    },
    updateMinutes(variable) {
      this.minutes = variable;
    },
    updateSeconds(variable) {
      this.seconds = variable;
    },
    logOut() {
      this.$store.dispatch('auth/logout');
      location.replace('/');
    }
  },
};
</script>
